"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const ExpansionPanel_1 = __importDefault(require("@material-ui/core/ExpansionPanel"));
const ExpansionPanelDetails_1 = __importDefault(require("@material-ui/core/ExpansionPanelDetails"));
const ExpansionPanelSummary_1 = __importDefault(require("@material-ui/core/ExpansionPanelSummary"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const evidence_defaults_context_1 = require("../../composite/evidence-defaults/evidence-defaults-context");
const compose_refs_1 = require("../../utils/compose-refs");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const panel_styles_1 = require("./panel-styles");
exports.Panel = (0, react_1.forwardRef)(function Panel({ children, label, summary, expandable = false, defaultExpanded = true, sideBorder = false, bottomBorder = true, unmountOnExit = false, className, fitHeight, classOverrides, }, ref) {
    const { root, fullHeight, summaryRoot, summaryFixed, detailsRoot, detailRootWithSideBorder, detailRootWithBottomBorder, labelRoot, summaryContent, summaryRootWithBorder, sumaryFullHeight, formPanelSummary, } = (0, panel_styles_1.useStyles)();
    const { panelUnmountOnExit: defaultUnmountOnExit } = (0, react_1.useContext)(evidence_defaults_context_1.EvidenceDefaultsContext);
    const anchorRef = (0, react_1.useRef)(null);
    const composedRef = (0, compose_refs_1.composeRefs)(ref, anchorRef);
    const [expanded, setExpanded] = (0, react_1.useState)(defaultExpanded);
    (0, react_1.useImperativeHandle)(ref, () => ({
        setExpanded,
        scrollIntoView: () => {
            var _a;
            (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        },
    }));
    const handleChange = (0, event_callback_hook_1.useEventCallback)((event, expanded) => {
        if (expandable) {
            setExpanded(expanded);
        }
    });
    return (react_1.default.createElement(ExpansionPanel_1.default, { className: className, classes: {
            root: (0, clsx_1.default)(root, { [fullHeight]: fitHeight }, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.root),
        }, square: true, expanded: expanded, onChange: handleChange, innerRef: composedRef, TransitionProps: {
            unmountOnExit: unmountOnExit || defaultUnmountOnExit,
            style: fitHeight
                ? {
                    flex: '1 1 auto',
                    overflowY: 'auto',
                }
                : undefined,
        } },
        react_1.default.createElement(ExpansionPanelSummary_1.default, { classes: {
                root: (0, clsx_1.default)(summaryRoot, {
                    [summaryFixed]: !expandable,
                    [summaryRootWithBorder]: sideBorder,
                    [sumaryFullHeight]: fitHeight,
                }, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.summaryRoot),
                content: (0, clsx_1.default)(summaryContent, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.summaryContent),
            }, expandIcon: expandable ? react_1.default.createElement(ExpandMore_1.default, null) : undefined },
            react_1.default.createElement(Typography_1.default, { classes: { root: (0, clsx_1.default)(labelRoot, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.labelRoot) }, variant: "h6" }, label),
            summary && (react_1.default.createElement(Typography_1.default, { component: "div", className: (0, clsx_1.default)(formPanelSummary, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.formPanelSummary) }, summary))),
        react_1.default.createElement(ExpansionPanelDetails_1.default, { classes: {
                root: (0, clsx_1.default)(detailsRoot, {
                    [detailRootWithBottomBorder]: bottomBorder,
                    [detailRootWithSideBorder]: sideBorder,
                }, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.detailsRoot),
            } }, children)));
});
//# sourceMappingURL=panel.js.map